import React, { useState, useEffect } from 'react';

import { Globals } from "root/DataFunctions/BaseDataFns";
import { getDocumentUrl } from "root/DataFunctions/CommonDataFns";

import ModalContentWrapper from '../ModalContentWrapper';
import MemberAccordion from '../ViewFamily/MemberAccordion';

const backArrowUrl = Globals.BaseURL + "/images/icons/child/arrow-left.svg";

const ModalViewMoreFamily = ({ families, title }) => {
    const [showMembers, setShowMembers] = useState(false);
    const [members, setMembers] = useState("");
    const [activeFamilyName, setActiveFamilyName] = useState("");

    const FamilyContent = ({ family }) => {
        const imageUrl = getDocumentUrl(family.enc_family_image_id, 200, true);

        return (
            <div 
                onClick={() => handleShowMembers(family.members, family.family_name)} 
                className="tree-member" 
            >
                <div className="accordion">
                    <div className="tree-member-name tree-member-name_more">
                        <div className="member-dp">
                            <img className="member-dp-img" src={imageUrl} alt={family.family_name} />
                        </div>
                        <div className="member-details-wrap">
                            <div className="member-details">
                                <p className="member-details-name">{family.family_name}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    const handleShowMembers = (members, family_name) => {
        setShowMembers(true);
        setMembers(members);
        setActiveFamilyName(family_name);
    }

    const MoreFamilyTitle = () => {
        return (
            <div className="tree-members_more-title">
                <span className="back" onClick={() => setShowMembers(false)}>
                    <img src={backArrowUrl} alt="Back" />
                </span>
                <h3>{activeFamilyName} Family</h3>
            </div>
        )
    }

    useEffect(() => {
        if(!showMembers) {
            setMembers("");
            setActiveFamilyName("");
        }
    }, [showMembers]);
    return (
        <div 
            className={!showMembers ?
                "tree-members tree-members_more"
                :
                "tree-members tree-members_more tree-members_show"
                }
        >
            <ModalContentWrapper>
                {activeFamilyName ? <MoreFamilyTitle /> : <h3>{title}</h3>}
                {/* {console.log(families)} */}
                <div className="tree-member-wrap">
                    {families && families.map(family => 
                        <FamilyContent key={family.id} family={family} />
                    )}
                </div>

                <div 
                    className={!showMembers ?
                        "tree-more-members"
                        :
                        "tree-more-members tree-more-members_show"
                        }
                >
                    {members && members.map((member) => 
                        <MemberAccordion key={member.ar_id} member={member} />
                    )}
                </div>
            </ModalContentWrapper>
        </div>
    )
}

export default ModalViewMoreFamily;
